import React from "react";

function BS4_Collapse() {
  return (
    <div>
      <h1>BS4_Collapse Component</h1>
      <p>This is the BS4_Collapse tutorial page content.</p>
    </div>
  );
}

export default BS4_Collapse;
